class PlotRasterLine extends React.Component {
  componentDidMount() {
    this.plot();
  }

  componentDidUpdate() {
    this.plot();
  }

  plot() {
    let { data, getX, getY, scaleX, scaleY, color } = this.props;

    let canvas = this.refs.canvas;
    canvas.width = canvas.width;

    let ctx = canvas.getContext("2d");

    let i = 0;
    let len = data.length;

    let x = (i) => scaleX(getX(data[i], i)) * 2;
    let y = (i) => scaleY(getY(data[i])) * 2;

    if (len) {
      ctx.strokeStyle = color;
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.moveTo(x(0), y(0));

      for (i = 1; i < len; i++) {
        ctx.lineTo(x(i), y(i));
      }

      ctx.stroke();
    }
  }

  render() {
    let { width, height } = this.props;

    return (
      <foreignObject className="mc-plot-raster-line" width={width} height={height}>
        <canvas ref="canvas" width={width * 2} height={height * 2} style={{ width, height }}/>
      </foreignObject>
    );
  }
}

PlotRasterLine.defaultProps = {
  color: "#304561"
};

module.exports = PlotRasterLine;
